import React, { useRef, useState } from "react";
import { CgChevronDoubleRight } from "react-icons/cg";
import { Link } from "react-router-dom";
import Nav from "./Nav";
import Shape from "./Shape";
const Header = () => {
  const headerRef = useRef();
  const [nav, setNav] = useState();
  window.onscroll = () => {
    if (window.scrollY >= headerRef.current.offsetHeight / 2) {
      headerRef.current.classList.add("slide-in");
      headerRef.current.classList.add("shadow-borderColor");
      headerRef.current.classList.add("bg-prColor/80");
    } else {
      headerRef.current.classList.remove("bg-prColor/80");
      headerRef.current.classList.remove("slide-in");
      headerRef.current.classList.remove("shadow-borderColor");
    }
  };
  return (
    <>
      <header className="fixed py-6 w-full z-20 shadow-md" ref={headerRef}>
        <div className="container flex justify-between items-center">
          <Link to="/" id="logo" className="logo">
            MNK DEV
          </Link>
          <Nav
            links={["home", "skills", "portfolio", "testimonials", "contact"]}
            setNav={setNav}
          />
          <div className="lg-hire-btn">
            <a
              href="https://www.upwork.com/freelancers/~01a8c06c7cdb1685cf"
              target={"_blank"}
              rel="noreferrer"
              className="btn-primary "
            >
              <span>Hire Me</span>
              <CgChevronDoubleRight />
            </a>
          </div>
          <div className="mb-menu-btn items-center gap-3 sm:gap-6">
            <a
              href="https://www.upwork.com/freelancers/~01a8c06c7cdb1685cf"
              target={"_blank"}
              rel="noreferrer"
              className="btn-primary"
            >
              <span>Hire Me</span>
              <CgChevronDoubleRight />
            </a>
            <button
              className="cursor-pointer"
              onClick={() => {
                nav.classList.toggle("active");
                document.body.style = "overflow:hidden";
              }}
            >
              <div className="bg-light w-1.5 h-1.5 xs:w-2 xs:h-2 rounded-full"></div>
              <div className="bg-light w-1.5 h-1.5 xs:w-2 xs:h-2 rounded-full my-1"></div>
              <div className="bg-light w-1.5 h-1.5 xs:w-2 xs:h-2 rounded-full"></div>
            </button>
          </div>
        </div>
      </header>
      <Shape
        position={{ top: "-20rem", left: "-12rem" }}
        dimension={{ first: "440px", second: "560px", third: "700px" }}
      />
    </>
  );
};

export default Header;
